import type { Vals } from '~lib';

export const AppModes = {
  Standalone: 'standalone',
  Platform: 'platform',
} as const;

export type TAppMode = Vals<typeof AppModes>;

/** @desc Reads app mode from Vite env, defaulting to platform for local development. */
export const appMode: TAppMode =
  import.meta.env.VITE_APP_MODE === AppModes.Standalone ? AppModes.Standalone : AppModes.Platform;

export const isPlatform = appMode === AppModes.Platform;
export const isStandalone = appMode === AppModes.Standalone;
